import { render } from "./ActionBranch.vue?vue&type=template&id=4e8e4e88"
import script from "./ActionBranch.vue?vue&type=script&lang=js"
export * from "./ActionBranch.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__